import React from 'react';
type ProgressBarProps = {
  progress: number;
  label?: string;
  showPercentage?: boolean;
};
export function ProgressBar({
  progress,
  label,
  showPercentage = true
}: ProgressBarProps) {
  return <div className="w-full" data-id="element-1421">
      {(label || showPercentage) && <div className="flex items-center justify-between mb-2" data-id="element-1422">
          {label && <span className="text-sm font-medium text-gray-700" data-id="element-1423">{label}</span>}
          {showPercentage && <span className="text-sm text-gray-600" data-id="element-1424">
              {Math.round(progress)}%
            </span>}
        </div>}
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-1425">
        <div className="h-full bg-green-500 rounded-full transition-all duration-300 ease-out" style={{
        width: `${Math.min(100, Math.max(0, progress))}%`
      }} data-id="element-1426" />
      </div>
    </div>;
}